export default __webpack_public_path__ + "static/media/my-job-not-select.7105cd36.svg";